<template>
  <v-app-bar app clipped-left color="primary">
    <span @click="navigateToHome" class="pl-2 mr-2 font-weight-light pointer" style="color: white; font-size: 25px;">

      <v-icon color="white">mdi-book-open-page-variant-outline</v-icon>

      <span v-if="!$vuetify.breakpoint.xsOnly" class="pl-1">taleem<span
          class="font-weight-black black--text">.app</span></span>
    </span>

    <v-app-bar-nav-icon v-if="currentUser.userType !== 'teacher'" @click.stop="drawerToggle" />

    <v-toolbar-title class="mr-12 align-center" v-if="currentUser.userType !== 'teacher'">
      <span class="title white--text text-capitalize">{{ currentBusiness.name }}</span>
    </v-toolbar-title>
    <!-- <v-btn @click="openSearchBox = true" outlined rounded raised small v-if="$vuetify.breakpoint.xsOnly">
      Search
    </v-btn>
    <GlobalSearch v-if="!$vuetify.breakpoint.xsOnly" /> -->
    <v-spacer />
    <UserMenu v-if="!$vuetify.breakpoint.xsOnly" />
    <v-dialog v-model="openSearchBox" fullscreen>
      <v-card>
        <ModelTitle title="Search" @close="openSearchBox = false" />
        <GlobalSearch @searched="openSearchBox = false" />
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import GlobalSearch from '@/modules/Layout/components/GlobalSearch.vue';
import UserMenu from "./Menu";
export default {
  data() {
    return {
      openSearchBox: false
    };
  },
  components: {
    GlobalSearch,
    UserMenu,
  },
  created() {
    // this.getCustomerList();
    console.log('currentBusiness', this.currentBusiness)
    console.log('currentUser', this.currentUser)
  },
  computed: {
    ...mapGetters("global", ["currentBusiness", "currentUser"])
  },
  methods: {
    ...mapActions("layout", ["drawerToggle"]),
    navigateToHome() {
      this.$router.push('/')
        .catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error(err);
          }
        });
    }
  }
};
</script>
